/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 *
 * The current setup is for "evergreen" browsers; the last versions of browsers that
 * automatically update themselves.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 * Disable patching of high-frequency or unnecessary APIs to reduce change detection overhead.
 */
;(window as any).__Zone_disable_requestAnimationFrame = true
;(window as any).__Zone_disable_on_property = true
;(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']

import 'zone.js' // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
